// 站点栏目、专题合集、FAQ 与品牌内容（纯静态展示用）
// 注：mocks 文件禁止互相 import，也不允许 default export。

export const siteMeta = {
  name: "吃瓜精选",
  slogan: "专题合集 × 分类盘点",
  tagline: "把碎片化娱乐信息整理成完整脉络，点开即得系统化追瓜内容。",
  description:
    "吃瓜精选专注娱乐专题合集与分类盘点：从明星恋情、行业秘闻到综艺名场面、社会热议，按主题汇总系列整理，脉络完整、分类清晰。",
  contactEmail: "hello@chigua-jingxuan.example.com",
};

export type Category = {
  slug: string;
  name: string;
  nameEn: string;
  brief: string;
  desc: string;
  cover: string;
};

export const categories: Category[] = [
  {
    slug: "starlove",
    name: "明星情感",
    nameEn: "Romance",
    brief: "恋情时间线、荧幕CP与背后的故事",
    desc: "从同框到官宣，从分手到复合，我们把明星情感里的关键节点按时间线整理清楚，还原每一段关系的完整脉络，不靠一张糊图断案。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20two%20silhouetted%20figures%20facing%20each%20other%20at%20dusk%20under%20warm%20string%20lights%2C%20rose%20red%20and%20gold%20color%20palette%2C%20romantic%20moody%20atmosphere%2C%20soft%20film%20grain%2C%20magazine%20spread%20aesthetic%2C%20blurred%20glowing%20bokeh%20background&width=1200&height=760&seq=cat-starlove&orientation=landscape",
  },
  {
    slug: "backstage",
    name: "行业秘闻",
    nameEn: "Industry",
    brief: "造星流水线、谈判桌与幕后的规则",
    desc: "选秀、经纪、打投、片约……娱乐圈是一个庞大的工业系统。我们拆解行业运行逻辑，把那些「台面上看不到」的流程讲明白。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20empty%20theater%20stage%20with%20spotlight%20and%20velvet%20curtains%2C%20backstage%20industry%20mood%2C%20deep%20crimson%20and%20warm%20gold%20lighting%2C%20dust%20particles%20in%20light%20beam%2C%20cinematic%20film%20grain%2C%20mysterious%20atmosphere&width=1200&height=760&seq=cat-backstage&orientation=landscape",
  },
  {
    slug: "variety",
    name: "综艺现场",
    nameEn: "Variety",
    brief: "名场面回顾、幕后与常驻嘉宾逻辑",
    desc: "那些被反复回味的综艺瞬间，背后是精心设计与临场发挥的共同作用。我们带你看懂现场，也看懂一档节目是怎么被做出来的。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20studio%20set%20photography%20of%20colorful%20variety%20show%20stage%20with%20warm%20spotlights%20and%20audience%20silhouettes%2C%20joyful%20energetic%20mood%2C%20terracotta%20orange%20and%20golden%20tones%2C%20cinematic%20grain%2C%20magazine%20editorial%20feel&width=1200&height=760&seq=cat-variety&orientation=landscape",
  },
  {
    slug: "society",
    name: "社会热议",
    nameEn: "Hot Topics",
    brief: "热搜事件如何被放大与反转",
    desc: "一条热搜从爆出到反转，往往藏着信息传播的规律。我们复盘热点事件的完整生命周期，帮你把情绪放一放，把逻辑看清楚。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20bustling%20city%20street%20at%20night%20with%20glowing%20digital%20screens%20and%20crowds%20silhouetted%2C%20modern%20urban%20mood%2C%20warm%20amber%20and%20crimson%20neon%20tones%2C%20motion%20blur%2C%20cinematic%20film%20grain&width=1200&height=760&seq=cat-society&orientation=landscape",
  },
];

export type Collection = {
  slug: string;
  title: string;
  subtitle: string;
  intro: string;
  cover: string;
  meta: string;
  featured?: boolean;
  chapters: { title: string; text: string }[];
  articleSlugs: string[];
};

export const collections: Collection[] = [
  {
    slug: "year-timeline",
    title: "年度吃瓜时间线",
    subtitle: "从一月到十二月，一口气追完今年那些大瓜",
    intro:
      "单条爆料总是七零八落，这一整年的人和事却往往彼此勾连。我们把本年度最具话题性的几段脉络按时间线重新串起来，从最初的同框、试水，到爆点、反转再到尘埃落定，让你一次看透每一个「完整的故事」。",
    cover:
      "https://readdy.ai/api/search-image?query=wide%20editorial%20composition%20of%20an%20arranged%20timeline%20of%20newspaper%20clippings%20and%20film%20photos%20on%20a%20warm%20paper%20desk%2C%20gold%20washi%20tape%2C%20crimson%20marker%20lines%20connecting%20events%2C%20vintage%20magazine%20collage%2C%20soft%20studio%20lighting%2C%20cinematic%20still%20life&width=1600&height=900&seq=col-yearline&orientation=landscape",
    meta: "专题合集 · 跨栏目全景盘点",
    featured: true,
    chapters: [
      { title: "开年信号", text: "一段从未被主流视野注意到的同框与点赞，成为整个故事被揭开的第一个引线。" },
      { title: "发酵与放大", text: "多个账号开始搬运拼图，舆论从「巧合」走向「实锤」，讨论度在一周内冲到顶峰。" },
      { title: "正面回应", text: "当事人先后发声，口径与时间差里藏着信息量，围观者开始分成不同立场。" },
      { title: "反转与余波", text: "新的物料与细节接连被挖出，剧情再度转向，最终归于各自的营业与生活。" },
    ],
    articleSlugs: ["fangyan-72h", "ai-love-shows", "hotsearch-timeline", "datou-pool"],
  },
  {
    slug: "variety-bts",
    title: "一档综艺的台前幕后全记录",
    subtitle: "从立项、选人到拍摄现场，看懂综艺是怎么被做出来的",
    intro:
      "我们常说「综艺有剧本」，可真正的制作远比「有剧本」复杂。这一专题带你走进一档慢综艺从立项、定角、彩排到剪辑上线的全过程，拆解名场面背后的规则与即兴。",
    cover:
      "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20photography%20of%20television%20production%20crew%20around%20a%20glowing%20studio%20set%2C%20cameras%20and%20monitors%2C%20warm%20terracotta%20and%20gold%20lighting%2C%20cinematic%20film%20grain%2C%20documentary%20editorial%20style%2C%20focused%20work%20atmosphere&width=1600&height=900&seq=col-varietybts&orientation=landscape",
    meta: "专题合集 · 综艺产业拆解",
    chapters: [
      { title: "立项：一个想法怎么变成一档节目", text: "从市场调研、题材立项到招商，一档节目在开拍前就已经经历多轮筛选与打磨。" },
      { title: "选人：常驻与飞行背后的逻辑", text: "选角并不只看流量，综艺感、档期、话题度与「化学反应」共同决定了一张名单。" },
      { title: "拍摄：现场的真实与设计", text: "好的名场面往往是「搭好框架后的自由发挥」，现场导演要做的更多是引导而非控制。" },
      { title: "剪辑与发酵", text: "素材进入机房后，节奏、情绪与二次话题点被逐帧重构，很多记忆点从这里诞生。" },
    ],
    articleSlugs: ["ai-love-shows", "slow-variety", "kaichang-moments", "zhuchichang-suanfa"],
  },
  {
    slug: "rise-and-fall",
    title: "从爆红到翻车：一个话题的完整生命周期",
    subtitle: "流量来得快也去得快，我们把「生命周期」拆给你看",
    intro:
      "当一个人或一件事突然爆红，接下来的每一步都会被无限放大。本专题复盘「爆红—膨胀—争议—跌落—再出发」的常见轨迹，试图回答那个更重要的问题：当流量退潮，还剩下什么。",
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20editorial%20photography%20of%20a%20glowing%20warm%20light%20rising%20and%20then%20scattering%20into%20embers%20over%20dark%20warm%20background%2C%20gold%20and%20crimson%20gradient%2C%20cinematic%20mood%2C%20rise%20and%20fall%20metaphor%2C%20film%20grain%2C%20magazine%20art%20direction&width=1600&height=900&seq=col-risefall&orientation=landscape",
    meta: "专题合集 · 现象级复盘",
    chapters: [
      { title: "爆红的偶然与必然", text: "一次出圈往往由作品、时机与传播机制的共振促成，偶然里也藏着必然。" },
      { title: "被放大的每一步", text: "走红之后，旧料被重翻、言行被逐帧检视，公众期待以极快的速度拉满。" },
      { title: "争议的临界点", text: "当事与愿违、或言行与预期背离时，情绪会迅速从追捧转向清算。" },
      { title: "流量退潮之后", text: "真正决定能否「再出发」的，不是一时热度，而是长期积累的作品与口碑。" },
    ],
    articleSlugs: ["daibohuofan", "hotsearch-timeline", "lianai-script", "xuanxiu-flow"],
  },
];

export type Faq = { q: string; a: string };
export const faqs: Faq[] = [
  {
    q: "专题合集和普通分类有什么不同？",
    a: "分类（如明星情感、综艺现场）是一个常设的内容货架，按主题把相关文章归类；专题合集则像一份「深度特刊」，围绕一个完整故事或现象，按时间线与章节重新组织，让你从起因看到结果。简单说：分类负责找，专题负责看透。",
  },
  {
    q: "你们的内容会及时更新吗？",
    a: "会的。我们会在热点事件进入尾声、脉络基本清晰后，第一时间补充并更新对应的专题与盘点，尽量不追第一时间的碎片噪声，而是给你整理后的完整版本。",
  },
  {
    q: "为什么你们不做「谁跟谁在一起了」这样的快讯？",
    a: "因为我们的定位是整理与复盘。单条爆料的信息量有限、且常被反转，我们更愿意等事件足够清晰后，再把同框、时间线、多方说法串成一个完整脉络，省去你自己拼凑的时间。",
  },
  {
    q: "我有个感兴趣的瓜或线索，怎么投稿？",
    a: "欢迎通过站内邮箱发给我们。请尽量附上来源与可核实的信息。我们会优先整理那些已具备多条信源、值得按脉络呈现的话题。",
  },
];

export const aboutContent = {
  lead: "吃瓜精选是一个娱乐内容的「整理者」。我们不追第一声枪响，而是等尘埃将定，把一件事的来龙去脉摊开给你看。",
  points: [
    { title: "脉络优先", text: "任何话题都用时间线与章节组织，还原完整过程，拒绝把结果甩给你。", icon: "ri-link" },
    { title: "分类清晰", text: "明星情感、行业秘闻、综艺现场、社会热议四大常设栏目，内容各归其位。", icon: "ri-folders-line" },
    { title: "深度盘点", text: "不只报热点，也拆行业规则与传播规律，帮你看懂背后的为什么。", icon: "ri-search-eye-line" },
    { title: "克制表达", text: "不确定的信息标清来源，多信源的话题给出不同面向，不引导站队。", icon: "ri-shield-check-line" },
  ],
};